export default "__VITE_ASSET__D6Fh7H5H__"